module.exports = __webpack_public_path__ + "static/media/texture-wood-dark-brown-v.13baeb44.jpg";